// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_BuscaOrcamentosDoClienteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/busca_orcamentos_do_cliente/{id}
 *
 * Returns list of orcamentos for a given cliente.
 */
import type { Orcamentos_BuscaOrcamentosDoClienteRow } from './Orcamentos_BuscaOrcamentosDoClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_BuscaOrcamentosDoClienteResponseDados = Orcamentos_BuscaOrcamentosDoClienteRow[];

export type Orcamentos_BuscaOrcamentosDoClienteResponse = ApiResponse<Orcamentos_BuscaOrcamentosDoClienteResponseDados>;

registerResponseContract('Orcamentos_BuscaOrcamentosDoClienteResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      orcamento_id:            { type: 'number',  required: true },
      orcamento_franquia_id:   { type: 'number',  required: true },
      orcamento_user_id:       { type: 'string',  required: true },
      orcamento_location_id:   { type: 'number',  required: false },
      orcamento_location_type: { type: 'string',  required: false },
      orcamento_valor:         { type: 'number',  required: true },
      orcamento_origem:        { type: 'number',  required: false },
      orcamento_data:          { type: 'string',  required: true },
      orcamento_status:        { type: 'string',  required: true },
      status_label:            { type: 'string',  required: true },
      orcamento_observacao:    { type: 'string',  required: false },
      orcamento_cliente_id:    { type: 'number',  required: false },
      franquia_nome:           { type: 'string',  required: false },
      Localidade:              { type: 'string',  required: false },
    },
  },
})
